import controller from './select-isa-modal.controller';
import template from './select-isa-modal.html';

/**
 * @param {any} resolve
 * @returns {import('angular').ui.bootstrap.IModalSettings}
 */
export default ({ resolve }) => ({
	template,
	resolve,
	size:         'sm',
	controller,
	controllerAs: '$ctrl',
});
